module.exports = __webpack_public_path__ + "img/fi-rr-user-delete.f026ee34.svg";